import React from "react";

const TakeYourTimeModal = ({ onClose }) => (
  <div className="modal show custom-modall" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header border-0">
          
          <button type="button" className="btn-close" onClick={onClose}></button>
          
        </div>
        <div className="modal-body text-center">
        <h5 style={{fontSize:"1.5rem"}}>
            Take your time. We're here whenever you're ready.
          </h5>
          </div>
      </div>
    </div>
  </div>
);

export default TakeYourTimeModal;


export const TakeYourTimeModalyesn = ({ onClose }) => (
  <div className="modal show custom-modall" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header border-0">
          
          <button type="button" className="btn-close" onClick={onClose}></button>
          
        </div>
        <div className="modal-body text-center">
        <h5 style={{fontSize:"1.5rem"}}>
            Whenever you're ready, we'll be here for you.
          </h5>
          </div>
      </div>
    </div>
  </div>
);
